<template>
  <div class="main" ref="main">
    <template v-if="hData.hvalue">
      <h1>当前健康值</h1>
      <el-button
        style="float: right; margin-top: -30px"
        @click="$router.go(-1)"
        size="mini"
        >返回</el-button
      >
      <div class="card hValue">
        <div class="card-title">
          <span class="card-title-icon"></span>
          <span class="card-title-name">健康值信息</span>
        </div>
        <el-row>
          <el-col :span="6">
            <div class="item-hValue">
              <circlehValue
                class="circlehValue"
                :pefectValue="hData.theoreticalHValue"
                :targetValue="
                  $store.state.isChannelArchive ? hData.targetHValue : 0
                "
                :progress="hData.hvalue"
                :colorValue="colorValue"
              ></circlehValue>
            </div>
            <p class="item-hValue-des">
              超过
              <span>{{ hData.percentageDistribution }}%</span>的同龄人
            </p>
            <p class="item-hValue-des1">
              综合健康状态：
              <span :style="{ color: colorValue }">{{ hData.userLevel }}</span>
            </p>
            <!-- <p class="item-hValue-suggest">{{hData.userLevelExplain}}</p> -->
          </el-col>
          <el-col :span="18" class="hValue-right">
            <div
              class="dimensionList"
              v-for="(item, index) in hData.dimensionList"
              :key="index"
            >
              <div class="dimensionList-name">{{ item.dimensionName }}</div>
              <div class="dimensionList-sub">
                <span class="dimensionList-sub-score">{{ item.score }}</span>
                <span class="dimensionList-sub-statu">{{
                  item.levelExplain
                }}</span
                ><span :style="{ color: getColor(item.level) }">{{
                  item.level
                }}</span>
              </div>
              <div class="dimensionList-des">
                {{ item.dimensionExplain }}
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="hvalue-compare">
          <p :style="{ width: diseaseRiskWidth + 'px' }">
            超过
            <span>{{ hData.percentageDistribution }}%</span>的同龄人
          </p>
          <hValueProgress
            class="hValueProgress"
            :currentValue="hData.hvalue"
            :perfectValue="hData.theoreticalHValue"
            ref="hValueProgress"
            @showWidth="showWidth"
          ></hValueProgress>
        </div>
        <div class="hValue-result">
          <div class="hValue-result-title">整体评价</div>
          <div class="hValue-result-des">{{ hData.userLevelExplain }}</div>
        </div>
        <div class="card-title">
          <span class="card-title-icon"></span>
          <span class="card-title-name">历史健康值健康趋势</span>
        </div>
        <div class="historyhealthTrend">
          <div class="h_select_history-box">
            <el-radio-group
              v-model="hcalc_history"
              size="small"
              class="h_select_history"
            >
              <el-radio-button label="all">全部</el-radio-button>
              <el-radio-button label="day">日历史</el-radio-button>
              <el-radio-button label="month">月历史</el-radio-button>
              <el-radio-button label="year">年历史</el-radio-button>
            </el-radio-group>
          </div>
          <div
            class="historyhealthTrendChart"
            ref="historyhealthTrendChart"
          ></div>
        </div>
      </div>
      <!-- <h1>健康值趋势预测</h1>
      <div class="m-target">
        <el-row >
          <el-col :span="12">
            <HcalcL class="target-left" :activeIndex="activeIndex" :mhcalc="mhcalcval"></HcalcL>
          </el-col>
          <el-col :span="12">
            <HcalcR
              class="target-right"
              :activeIndex="activeIndex"
              :submitdata="sbmtdata"
              @mhcalc="mhcalc"
              :hcalcre='hcalcrebul'
              :ispid='ispid'
              :hval="hData.hvalue"
            ></HcalcR>              
          </el-col>            
        </el-row>  
      </div>          -->
    </template>
    <template v-else>
      <div class="healthNonData">
        <img
          src="../../../assets/images/hcalc2.png"
          class="healthNonDataImage"
          alt=""
        />
        <div class="healthNonDataText">暂无健康值信息</div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  getPersionHValueDetail,
  getHealthHValue,
  getUserHistoryHValue,
} from "../../../config/healthApi.js";
import circlehValue from "../../../components/health/circlehValue";
import hValueProgress from "../../../components/health/hValueProgress";
// import HcalcL from '../../../components/health/hcalc-assy/hcalc-l.vue'
// import HcalcR from '../../../components/health/hcalc-assy/hcalc-r.vue'
import { h_trend_history } from "@/assets/js/echarts.js";
import {
  isEmpty,
  getYMDString,
  getYMString,
  getYMDSimple,
} from "@/assets/js/until.js";
export default {
  components: {
    circlehValue,
    hValueProgress,
    // HcalcL,
    // HcalcR,
  },
  name: "health-hvalue",
  data() {
    return {
      // 环形七种颜色
      colorList: [
        "#A0523D",
        "#C36447",
        "#DB7957",
        "#F0A700",
        "#9ED500",
        "#40CF57",
        "#16D18D",
        // "#9B2800",
        // "#C53A09",
        // "#E85420",
        // "#F7B500",
        // "#E1E700",
        // "#A4D90F",
        // "#6DD400",
      ],
      textArray: ["极差", "很差", "较差", "一般", "较好", "很好", "极好"],
      colorValue: "",
      diseaseRiskWidth: 0,
      hcalc_history: "all",
      trend_history_echart: {},
      hData: {
        dimensionList: [],
        hvalue: 0,
      },
      activeIndex: 2,
      mhcalcval: [1, 234],
      // mhcalcval: [],
      hcalcrebul: true,
      ispid: true,
      sbmtdata: {
        disNameArr: [],
      },
    };
  },
  created() {
    // this.hData = this.$store.state.healthDocUser.healthData;
    // 936954677
    this.ispid = this.$store.state.healthDocUser.isChannelArchive;
  },
  mounted() {
    this.getPersionHValueDetail();
  },
  methods: {
    getColor(val) {
      return this.colorList[this.textArray.indexOf(val)];
    },
    async getPersionHValueDetail() {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getHealthHValue({
          phoneNum: phone,
        });
      } else {
        data = await getPersionHValueDetail({
          userId: this.$store.state.healthDocUser.userId,
        });
      }
      if (data.code == 200) {
        let respondData = data.data;
        respondData.hvalue = respondData.hvalue || respondData.hValue;
        respondData.hage = respondData.hage || respondData.hAge;
        this.colorValue =
          this.colorList[this.textArray.indexOf(respondData.userLevel)];
        console.log(this.colorValue);
        respondData.hageExplain =
          respondData.hAgeExplain || respondData.hageExplain;
        respondData.percentageDistribution =
          respondData.percentageDistribution ||
          respondData.distributionPercentage;
        respondData.percentageDistribution = respondData.percentageDistribution
          ? `${respondData.percentageDistribution}`
          : "0";
        this.$nextTick(() => {
          if (!isEmpty(respondData.riskFactorList)) {
            let controlRiskList = [];
            let ristArr = [];
            respondData.riskFactorList.forEach((item) => {
              //可控风险因素
              if (item.hasControl) {
                let newItem = {};
                newItem.label = item.riskFactorId;
                newItem.value = item.riskFactorName;
                controlRiskList.push(newItem);
                ristArr.push(item.riskFactorId);
              }
            });
            this.sbmtdata.disNameArr = controlRiskList;
            // this.mhcalcval = [respondData.hvalue, respondData.hvalue];
            if (!this.$store.state.healthDocUser.isChannelArchive) {
              this.getHealthUserHValueTrend(100, 21, ristArr);
            } else {
              this.getHealthUserHValueTrendpid(100, 21, ristArr);
            }
          }
          respondData.hValue = 666;
          this.hData = respondData;

          let hvalueSize = 10;
          this.getUserHValueHistory("all", hvalueSize);
        });
      }
    },
    async getHealthUserHValueTrendpid(
      averageMValue,
      managementDay,
      riskFactorIdList
    ) {
      // const data = await getHealthUserHValueTrendpid({
      //   userId: this.$store.state.healthDocUser.userId,
      //   averageMValue, // M值
      //   managementDay, //管理天数
      //   riskFactorIdList, //风险因数集合
      //   appId: this.$store.state.healthDocUser.customerAppId,
      //   profileId: this.$store.state.healthDocUser.profileId,
      // });
      // if (data.code == 200) {
      //   this.mhcalcval = data.data;
      //   // this.$emit('mhcalc', data.data)
      // }
    },

    async getHealthUserHValueTrend(
      averageMValue,
      managementDay,
      riskFactorIdList
    ) {
      // TODO
      // const data = await getHealthUserHValueTrend({
      //   userId: this.$store.state.healthDocUser.userId,
      //   averageMValue, // M值
      //   managementDay, //管理天数
      //   riskFactorIdList, //风险因数集合
      //   phoneNumber: this.$store.state.healthDocUser.phone,
      // });
      // if (data.code == 200) {
      //   this.mhcalcval = data.data;
      //   // this.$emit('mhcalc', data.data)
      // }
    },

    showWidth(width) {
      this.diseaseRiskWidth = width;
    },
    async getUserHValueHistory(type) {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        if (type == "all") {
          data = await getUserHistoryHValue({
            userId: this.$store.state.healthDocUser.userId,
            phoneNumber: phone,
          });
        } else {
          data = await getUserHistoryHValue({
            userId: this.$store.state.healthDocUser.userId,
            phoneNumber: phone,
          });
        }
      } else {
        data = await getUserHistoryHValue({
          userId: this.$store.state.healthDocUser.userId,
          type: type,
        });
      }
      if (data.code == 200) {
        let respondData = data.data;
        this.$nextTick(() => {
          this.drawChart1(respondData, type);
        });
      }
    },
    drawChart1(data, type) {
      // var colors = ["#E7E7E7", "#78B1F2", "#41CED4", "#78B1F2"];
      let echartData = [];
      let xAxisData = [];
      data.forEach((item, index) => {
        if (item.hValue) {
          let obj = {
            name: item.hValueLabelName,
            value: item.hValue,
          };
          echartData.push(obj);
          if (index < data.length - 1) {
            let date =
              type == "r"
                ? getYMDString(item.dataTime)
                : getYMDString(item.dataTime);
            xAxisData.push(date);
          } else {
            xAxisData.push("当前");
          }
        }
      });
      // 基于准备好的dom，初始化echarts实例,绘制图表
      let historyhealthTrendChart = this.$refs.historyhealthTrendChart;
      if (!historyhealthTrendChart) {
        return;
      }
      this.trend_history_echart = {
        xAxisData,
        echartData,
      };
      var myChart = this.$echarts.init(historyhealthTrendChart);
      h_trend_history(myChart, xAxisData, echartData);
    },
    mhcalc(data) {
      this.mhcalcval = data;
    },
  },
  watch: {
    hcalc_history(type) {
      let historyhealthTrendChart = this.$refs.historyhealthTrendChart;
      let myChart = this.$echarts.init(historyhealthTrendChart);
      myChart.clear();
      this.getUserHValueHistory(type);
    },
  },
};
</script>

<style scoped>
.main {
  min-width: 1080px;
  /* padding-left: 16px; */
  /* padding-right: 30px; */
  /* padding: 100px 0; */
  overflow: scroll;
  position: relative;
  height: 100%;
  overflow-x: hidden;
}

h1 {
  padding-top: 20px;
  color: #333333;
  font-size: 16px;
}
.card {
  position: relative;
  background-color: #fff;
  overflow: hidden;
}
.card-title {
  margin-top: 16px;
  height: 16px;
  position: relative;
}
.card-title-icon {
  background-color: #0062ff;
  display: inline-block;
  width: 4px;
  height: 14px;
  position: absolute;
  transform: translate(0, -50%);
  top: 50%;
  left: 18px;
}
.card-title-name {
  margin-left: 0px;
  font-size: 16px;
  line-height: 16px;
  color: #3b4859;
  font-family: PingFangSC-Medium;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  left: 30px;
}

.hValue {
  /* height: 360px; */
  margin-top: 18px;
  position: relative;
  margin-bottom: 20px;
}

.item-hValue {
  margin-top: 40px;
}

.circlehValue {
  margin: 0 auto;
  width: 100%;
  height: 220px;
}

.item-hValue-des {
  text-align: center;
  color: #666;
  font-size: 14px;
}

.item-hValue-des span {
  font-family: PingFangSC-Medium;
  color: #0078fc;
  font-size: 16px;
}

.item-hValue-des1 {
  text-align: center;
  color: #666;
  font-size: 17px;
}

.item-hValue-des1 span {
  font-family: PingFangSC-Medium;
  color: #0078fc;
  font-size: 18px;
}

/* .dimensionList:last-child {
} */

.dimensionList {
  background: rgba(0, 0, 0, 0.03);
  padding: 16px 12px;
  margin-top: 6px;
  margin-right: 18px;
}
.dimensionList-name {
  font-family: PingFangSC-Semibold;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0;
  line-height: 20px;
}
.dimensionList-sub {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  line-height: 14px;
  margin-top: 12px;
}
.dimensionList-sub-statu {
  margin-left: 6px;
}
.dimensionList-des {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  margin-top: 6px;
}

.item-hValue-suggest {
  font-size: 12px;
  color: #999999;
  text-align: justify;
  padding: 8px 10px;
  margin: 13px 8px 8px 8px;
  background-color: rgba(0, 0, 0, 0.03);
  position: absolute;
  left: 0;
  bottom: 0;
}

.hvalue-compare {
  margin: 20px 0px;
  width: 100%;
  position: relative;
}

.hvalue-compare p {
  position: absolute;
  left: 0;
  top: 35px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
  line-height: 12px;
}
.hvalue-compare p span {
  font-family: PingFangSC-Semibold;
  font-size: 12px;
  color: #fc8c41;
  letter-spacing: 0;
  line-height: 12px;
}

.hValueProgress {
  width: 100%;
  height: 200px;
  background-color: #fff;
}

/* <div class="hValue-result">
          <div class="hValue-result-title">整体评价</div>
          <div class="hValue-result-des">{{hData.userLevelExplain}}</div>
      </div> */

.hValue-result {
  margin: 18px;
  padding: 12px 16px 14px 16px;
  background-color: rgba(0, 119, 249, 0.06);
}
.hValue-result-title {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #333333;
  line-height: 16px;
}
.hValue-result-des {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #999999;
  line-height: 12px;
  margin-top: 6px;
}

/* .healthTrend {
  margin-top: 20px;
}

.healthTrend p {
  margin-top: 10px;
}

.healthTrend-hvalue {
  font-size: 14px;
  color: gray;
}

.healthTrend-hvalue span {
  color: lightblue;
}

.healthTrend-des {
  font-size: 14px;
  color: gray;
}

.healthTrendChart {
  margin-top: 10px;
  width: 100%;
  height: 400px;
  background-color: lightgray;
} */

.historyhealthTrend {
  margin: 20px 0px;
}

.historyhealthTrendChart {
  width: 100%;
  height: 400px;
  background-color: #fff;
}

.healthNonData {
  position: relative;
  height: 600px;
}

.healthNonDataImage {
  width: 400px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.healthNonDataText {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #999999;
  text-align: center;
  position: absolute;
  left: 0px;
  bottom: 100px;
}

.m-target {
  margin-top: 18px;
  position: relative;
  background-color: #fff;
}

.target-left {
}

.target-right {
}

.h_select_history-box {
  height: 32px;
}

.h_select_history {
  /* display: flex;
  justify-content: right; */
  margin-right: 30px;
  float: right;
}
</style>
